import { EventEmitter, Injectable, Injector } from '@angular/core';
import { ApiService, FeatureService } from '@netfoundry-ui/shared/services';
import { EdgeRouterServiceV2 } from '@netfoundry-ui/shared/apiv2';
import { DataTableFilterService, ExtensionService, FilterObj, GrowlerService, ServiceFormService, ServicesPageService } from 'ziti-console-lib';

import { MatDialog } from '@angular/material/dialog';
import { MetricsModalComponent } from '@netfoundry-ui/feature/metrics-modal';
import { DialLogsTimelineDrawerService } from '@netfoundry-ui/feature/dial-logs-timeline';

import { isEmpty } from 'lodash';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServicesExtensionService implements ExtensionService {

  hosting = false;
  errors: any = {};
  closed: any = new EventEmitter<any>();
  consoleActionTriggered: any = new EventEmitter<any>();
  currentNetwork: any = {};
  dialogRef: any;

  formDataChanged: any = new BehaviorSubject<any>({isEmpty: true});
  closeAfterSave = true;
  useDeleteSplitButton = true;

  moreActions = [];

  listActions = [
    {name: 'Show Metrics', action: 'show-metrics', label: 'Show Metrics', callback: this.showMetricsModal.bind(this), hidden: this.hideEventsTableAction.bind(this)},
    {name: 'Show Dial Logs', action: 'show-dial-logs', label: 'Show Dial Logs', callback: this.showDialLogsModalFromListPage.bind(this), hidden: this.hideEventsTableAction.bind(this)}
  ];

  formData: any = {};

  isAdminColumnFilterActive = false;

  constructor(
    private edgeRouterService: EdgeRouterServiceV2,
    private apiService: ApiService,
    private growlerService: GrowlerService,
    private dialogForm: MatDialog,
    protected filterService: DataTableFilterService,
    private injector: Injector,
    private featureService: FeatureService,
    private dialLogsDrawer: DialLogsTimelineDrawerService,
  ) {
    this.apiService.currentNetwork.subscribe((network) => {
      this.currentNetwork = network;
    });
    this.consoleActionTriggered.subscribe(({ action, page, item, type }: any) => {
      if (action === 'edit' || !(window as any)?.gtag || !page) {
        return;
      }
      (window as any).gtag('event', `${action}_${page}`, {
        [`${page}_name`]: item?.name,
        [`${page}_id`]: item?.id,
      });
    });
    this.filterService.filtersChanged.subscribe((event: any) => {
      this.isAdminColumnFilterActive = false;
      this.filterService.filters.forEach((filter: any) => {
        if (filter.columnId === 'isAdmin') {
          this.isAdminColumnFilterActive = filter.hidden !== true;
        }
      });
    });
  }

  private get serviceFormService(): ServiceFormService {
    return this.injector.get(ServiceFormService);
  }

  extendOnInit() {
    //this.initAdminFilter();
  }

  hideEventsTableAction(item: any) {
    return false;
  }

  hideMetricsTableAction(item: any) {
    return false;
  }

  hideDialLogsTableAction(item: any) {
    return false;
  }

  hideEventsAction() {
    return isEmpty(this.serviceFormService?.formData?.id);
  }

  hideMetricsAction() {
    return isEmpty(this.serviceFormService?.formData?.id);
  }

  hideDialLogsAction() {
    return isEmpty(this.serviceFormService?.formData?.id);
  }

  updateFormData(data: any) {
    this.formData = data;
  }

  showMetricsModal(data?: any) {
    this.dialogForm.open(MetricsModalComponent, {
      data: {
        resourceType: 'service',
        model: data || this.formData,
        networkGroupId: this.currentNetwork.networkGroupId,
        networkId: this.currentNetwork.id,
      },
      height: '800px',
      width: '1200px',
      autoFocus: false,
    });
  }

  showDialLogsModal(siblings: { id: string; name?: string }[] = []) {
    this.dialLogsDrawer.open(
      {
        resourceType: 'service',
        model: this.formData,
        networkGroupId: this.currentNetwork.networkGroupId,
        networkId: this.currentNetwork.id,
      },
      siblings
    );
  }

  showDialLogsModalFromListPage(zitiIdentity: any) {
    this.formData = zitiIdentity;
    // Open now; the services list page (unlike identities) emits no table-data
    // event, so fetch the current page's ordered rows to fill the prev/next pager.
    this.showDialLogsModal([]);
    try {
      const pageService: any = this.injector.get(ServicesPageService);
      pageService
        .getData(this.filterService.filters, pageService.currentSort, this.filterService.currentPage)
        .then((results: any) => {
          if (Array.isArray(results?.data)) {
            this.dialLogsDrawer.setSiblings(
              results.data.filter((r: any) => r?.id).map((r: any) => ({ id: r.id, name: r.name }))
            );
          }
        })
        .catch(() => {
          /* no siblings → pager just stays hidden */
        });
    } catch {
      /* ServicesPageService unavailable → pager stays hidden */
    }
  }

  extendAfterViewInits(extentionPoints: any): void {}

  initAdminFilter() {
    const filterObj: FilterObj = {
      filterName: 'Admins',
      columnId: 'isAdmin',
      value: false,
      label: 'Non-Admins',
      type: 'BOOLEAN',
    };
    this.filterService.filters = [filterObj];
    this.filterService.filtersChanged.next(this.filterService.filters);
  }

  updateAdminFilter(showAdmin: any) {
    if (showAdmin) {
      this.filterService.filters = this.filterService.filters.filter((filter: any) => {
        return filter.columnId !== 'isAdmin';
      });
    } else {
      const filterObj: FilterObj = {
        filterName: 'Admins',
        columnId: 'isAdmin',
        value: false,
        label: 'Admins',
        type: 'BOOLEAN',
      };
      this.filterService.filters.push(filterObj);
    }
    this.filterService.filtersChanged.next(this.filterService.filters);
  }

  validateData(): Promise<any> {
    return Promise.resolve(true);
  }

  formDataSaved(data: any): Promise<any> {
    return Promise.resolve(data);
  }

  processTableColumns(tableColumns: any): any[] {
    return tableColumns;
  }

  get showApiCalls(): boolean {
    return this.featureService.powerUserEnabled;
  }

}
